import { render } from "./VisualizzaSala.vue?vue&type=template&id=5008087a&scoped=true"
import script from "./VisualizzaSala.vue?vue&type=script&lang=js"
export * from "./VisualizzaSala.vue?vue&type=script&lang=js"

import "./VisualizzaSala.vue?vue&type=style&index=0&id=5008087a&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5008087a"]])

export default __exports__